import React, { useContext } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import RemoveDialog from "../../Components/RemoveDialog";

import * as api from "../../services";
import LibraryContext from "../libraryContext";
import { useGetSeachParam, useDeleteSearchParam } from "../../useSearchParams";
import { useTranslation } from "react-i18next";
import AppContext from "../../appContext";
import MutationMessage from "../../Components/MutationMessage";

export default function RemoveSurveyDialog({ open, setOpen }) {
  const history = useHistory();
  const { t } = useTranslation();
  const {
    app: {
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const { handleQuery } = useContext(LibraryContext);
  const interactionId = Number(useGetSeachParam("i"));
  const closeInteraction = useDeleteSearchParam("i");
  const removeMutation = useMutation(
    () =>
      api.postPublicInteraction({
        interactionId,
        interactionJSON: "",
        name: "",
        description: "",
        _public: 0,
        projectId,
        sessionId,
      }),
    {
      onSuccess: (data) => {
        if (data.data?.status === 1) {
          history.push({ search: closeInteraction }); // close the right panel
          handleQuery({ type: "refresh" }); // trigger the old data to be updated
        }
      },
    }
  );

  return (
    <div>
      <MutationMessage
        mutation={removeMutation}
        text={{
          loading: t("common.notifications.removeLoading"),
          success: t("common.notifications.removeSuccess"),
        }}
      />
      <RemoveDialog
        open={open}
        setOpen={setOpen}
        removeFunction={() => removeMutation.mutate()}
        dialogTitle={t("surveys.deleteDialog.title")}
        dialogContentText={t("surveys.deleteDialog.text")}
        dialogActionCancel={t("surveys.deleteDialog.cancel")}
        dialogActionConfirm={t("surveys.deleteDialog.confirm")}
      />
    </div>
  );
}
